
    var riot = require('riot')
    import { Collections } from './gb-collections';
riot.tag2('gb-collections', '<yield> <gb-list class="gb-collections" if="{!$collections.dropdown}" inline> <gb-collection-item></gb-collection-item> </gb-list> <gb-select if="{$collections.dropdown}"> <gb-custom-select> <gb-collection-dropdown-item></gb-collection-dropdown-item> </gb-custom-select> </gb-select> </yield>', 'gb-collections.gb-stylish gb-custom-select gb-list > ul > li,[data-is="gb-collections"].gb-stylish gb-custom-select gb-list > ul > li{ padding: 4px 10px; }', '', function(opts) {
    this._mixin(Collections);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/collections/gb-collections.tag.html